import { render, staticRenderFns } from "./funding.vue?vue&type=template&id=7ba3a0ae&lang=pug&"
import script from "./funding.vue?vue&type=script&lang=js&"
export * from "./funding.vue?vue&type=script&lang=js&"
import style0 from "./funding.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba3a0ae')) {
      api.createRecord('7ba3a0ae', component.options)
    } else {
      api.reload('7ba3a0ae', component.options)
    }
    module.hot.accept("./funding.vue?vue&type=template&id=7ba3a0ae&lang=pug&", function () {
      api.rerender('7ba3a0ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/funding.vue"
export default component.exports